import React from 'react';
import { Spinner, Table } from 'react-bootstrap'

import DefaultButton from 'components/mycomponents/DefaultButton';
import { dateTimeFormat } from '../../../utils/FormatDate'

const Data = ({
    dataMain,
    actionDetail,
    actionEdit,
    actionDelete,
    numberStart,
    isLoading
}) => {
    return (
        <Table responsive striped hover bordered size="sm">
            <thead>
                <tr>
                    <th scope="col">No</th>
                    <th scope="col">No Kend.</th>
                    <th scope="col">Jenis Kend.</th>
                    <th scope="col">Lokasi Parkir</th>
                    <th scope="col">Tanggal / Jam Masuk</th>
                    <th scope="col">Tanggal / Keluar</th>
                    <th scope="col">Status</th>
                    <th scope="col">Biaya</th>
                    <th className="text-end" scope="col" width="7%">
                        Aksi
                    </th>
                </tr>
            </thead>
            <tbody>
                {
                    isLoading ? (<tr>
                        <td colSpan={6} align="center" valign="middle">
                            <Spinner animation="border  " className="me-2" />
                            <span className="fs-4">Loading ...</span>
                        </td>
                    </tr>) :
                    dataMain ? dataMain.map((val, idx) => {
                        return (
                            <tr key={idx}>
                                <td>{numberStart + 1 + idx}</td>
                                <td>{val.vclicense_number}</td>
                                <td>{val.vcvehicle_type}</td>
                                <td>{val.vclocation}</td>
                                <td>{dateTimeFormat(val.dtcheck_in)}</td>
                                <td>{parseFloat(val.intstatus) === 2 ? dateTimeFormat(val.dtcheck_out) : ''}</td>
                                <td>{val.vcstatus}</td>
                                <td align='right'>{parseFloat(val.decamount).toLocaleString('id')}</td>
                                <td className="text-end">
                                    <DefaultButton icon="info" title="Detail Data" variant="action" className="p-0 me-3" clickAction={actionDetail} clickParam={val.intid} />
                                    {/* <DefaultButton icon="edit" title="Edit" variant="action" className="p-0 me-3" clickAction={actionEdit} clickParam={val.intid} />
                                    <DefaultButton icon="trash-alt" title="Delete" variant="action" className="p-0" clickAction={actionDelete} clickParam={val.intid} /> */}
                                </td>
                            </tr>
                        );
                    }) : (
                        <tr>
                            <td colSpan={9}>Data Tidak Tersedia.</td>
                        </tr>
                    )
                }
            </tbody>
        </Table>
    );
}

Data.propTypes = {}

export default Data;